import { Mail, Shield, User } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Tooltip } from '@/components/ui/Tooltip'
import DeleteButton from '@/components/ui/DeleteButton'

interface PendingInvitation {
  id: string
  email: string
  role: 'admin' | 'agent'
  invited_by_name: string
  expires_at: string
  created_at: string
}

const roleIcons = {
  admin: Shield,
  agent: User,
}

const roleLabels = {
  admin: 'Admin',
  agent: 'Agent',
}

interface PendingInvitationRowProps {
  invitation: PendingInvitation
  canManage: boolean
  onResend: (invitationId: string) => void
  onRevoke: (invitationId: string) => void
}

export function PendingInvitationRow({
  invitation,
  canManage,
  onResend,
  onRevoke,
}: PendingInvitationRowProps) {
  const RoleIcon = roleIcons[invitation.role]

  return (
    <div className="flex items-center gap-3 p-3 bg-muted/30 border border-dashed border-border rounded-lg group">
      <div className="size-10 rounded-full bg-muted flex items-center justify-center">
        <Mail className="size-5 text-muted-foreground" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-medium truncate">{invitation.email}</span>
          <span className="flex items-center gap-1 text-xs bg-muted px-2 py-0.5 rounded">
            <RoleIcon className="size-3" />
            {roleLabels[invitation.role]}
          </span>
        </div>
        <div className="text-sm text-muted-foreground">
          Invited by {invitation.invited_by_name}
        </div>
      </div>
      {canManage && (
        <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100">
          <Tooltip content="Resend invitation">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onResend(invitation.id)}
              className="cursor-pointer"
            >
              <Mail className="size-4" />
            </Button>
          </Tooltip>
          <DeleteButton
            onDelete={() => onRevoke(invitation.id)}
            initialText=""
            confirmText="Revoke?"
          />
        </div>
      )}
    </div>
  )
}
